import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import GiftModalStore from './store';
import cx from 'classnames';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
const pageLocalesData = getPageLocalesData();
const mainLocalesData = pageLocalesData.main;
const styles = require('./index.less');

/**
 *  典藏礼包弹窗
 * @param store {AppointmentModalStore}
 * @param onClose
 * @returns {JSX.Element}
 * @constructor
 */
const GiftModal = ({ store, onClose }) => {
  store.use();
  store.onClose = onClose;

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.root, 'page-main')}>
        <div className="content">
          <div className="close" onClick={store.onCloseHandler} />
          <div className="title">{mainLocalesData.title}</div>
          <div className={styles.textBox}>
            <div className="text1">{mainLocalesData.giftModalText1}</div>
            <div className="text2">{mainLocalesData.giftModalText2}</div>
            <div className="text3">{mainLocalesData.giftModalText3}</div>
          </div>
          <div className="btnBox">
            <div className="btn1">{mainLocalesData.giftModalBtnText1}</div>
            <div className="btn2">{mainLocalesData.giftModalBtnText2}</div>
          </div>
        </div>
      </div>
    </ModalContainer>
  );
};
export default wrapStore(GiftModal, GiftModalStore);
